var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarimoscaMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 239.995,
    height: 32.923,
    viewBox: "0 0 239.995 32.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 239.995,
    height: 32.923,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M108.52,45.141V19.761h4.566L121.9,34.841l8.849-15.079h4.531v25.38h-4.248V26.806l-9.168,15.769-9.1-15.8V45.141Z",
    transform: "translate(-69.594 -12.673)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M191.266,45.142l10.194-25.38h4.779L216.4,45.142h-4.6l-2.036-5.292H197.9l-2.018,5.292Zm8.088-9.026h8.991l-4.5-11.7Z",
    transform: "translate(-122.659 -12.674)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M269.569,45.142V19.762h9.611a7.957,7.957,0,0,1,5.787,1.982A7.213,7.213,0,0,1,287,27.16q0,5.717-5.646,6.779l7.611,11.2h-5.151l-7.1-10.832h-2.9V45.142Zm4.248-14.424h4.814a5.08,5.08,0,0,0,3.071-.8,3.18,3.18,0,0,0,1.071-2.725,3.2,3.2,0,0,0-1.08-2.726,5,5,0,0,0-3.062-.814h-4.814Z",
    transform: "translate(-172.875 -12.673)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 4.248,
    height: 25.38,
    transform: "translate(119.384 7.089)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M362.324,19.876h2.515l4.394,22.817h.071l12.755-22.817h2.8l-4.889,25.333H378.2l4.428-22.96h-.07s-1.063,1.878-1.949,3.508L369.729,45.209h-1.807L364.2,25.757c-.248-1.346-.531-3.508-.531-3.508H363.6l-4.429,22.96h-1.736Z",
    transform: "translate(-229.224 -12.746)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M435.665,33.87c0-7.511,4.429-15.377,12.436-15.377,5.74,0,10.1,4.181,10.1,10.984,0,7.511-4.181,15.306-12.507,15.306-5.7,0-10.027-4.074-10.027-10.913m10.1,9.283c6.944,0,10.523-6.838,10.523-13.676,0-5.385-3.083-9.354-8.255-9.354-6.909,0-10.452,6.8-10.452,13.747,0,5.315,2.941,9.283,8.184,9.283",
    transform: "translate(-279.393 -11.859)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M499.768,36.315h1.807c-.071,4.712,2.763,6.909,7.37,6.909,3.613,0,7.086-1.736,7.086-6.236,0-2.587-1.984-3.791-6.555-5.244-4.571-1.488-6.8-2.87-6.8-6.307,0-4.429,3.862-6.945,8.4-6.945,4.57,0,7.9,2.2,8.007,7.051h-1.772c-.106-3.614-2.622-5.492-6.307-5.492-3.543,0-6.519,1.594-6.519,5.385,0,2.374,1.7,3.437,5.456,4.641,4.677,1.524,7.937,2.764,7.937,6.909,0,5.1-4.146,7.795-9,7.795-5.244,0-9.177-2.516-9.106-8.468",
    transform: "translate(-320.502 -11.859)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M557.062,34.224c0-7.263,4.039-15.731,12.719-15.731,4.43,0,7.8,2.409,8.433,7.44h-1.772a6.324,6.324,0,0,0-6.767-5.881c-7.653,0-10.7,7.653-10.7,14.137,0,5.208,2.267,9,7.759,9,4.641,0,7.83-3.224,8.964-8.042h1.736c-1.382,5.81-5,9.637-10.771,9.637-6.236,0-9.6-4.252-9.6-10.559",
    transform: "translate(-357.245 -11.859)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M628.291,37.06H617.13l-4.393,8.149h-1.843l13.641-25.333h2.09l5.138,25.333h-1.842Zm-10.346-1.524h10.027l-1.985-10.062c-.283-1.453-.673-3.791-.673-3.791h-.071s-.992,2.126-1.913,3.827Z",
    transform: "translate(-391.768 -12.746)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M470.784,3.547,477.26,0l.717,1.648-6.624,3.043Z",
    transform: "translate(-301.915 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M22.9,37.427,29.989,32.6a1.676,1.676,0,0,0,.685-1.39v-.927a1.509,1.509,0,0,0-1.382-1.609H15.537a1.194,1.194,0,0,0-.2.019,1.193,1.193,0,0,0-.2-.019H1.382A1.509,1.509,0,0,0,0,30.283v.9a1.677,1.677,0,0,0,.683,1.388l7.1,4.849a1.752,1.752,0,0,1,0,2.777L.685,45.027A1.675,1.675,0,0,0,0,46.416v.928a1.509,1.509,0,0,0,1.382,1.609H15.137a1.193,1.193,0,0,0,.2-.019,1.193,1.193,0,0,0,.2.019H29.291a1.509,1.509,0,0,0,1.382-1.609v-.9a1.675,1.675,0,0,0-.683-1.388l-7.1-4.849a1.753,1.753,0,0,1,0-2.778M21.629,34.9,17.9,37.4a1.751,1.751,0,0,0-.005,2.786l3.765,2.548c1.221.826.717,3-.695,3H15.537a1.194,1.194,0,0,0-.2.019,1.193,1.193,0,0,0-.2-.019h-5.4c-1.415,0-1.917-2.182-.69-3l3.733-2.5a1.751,1.751,0,0,0,.005-2.786L9.018,34.893c-1.221-.826-.717-3,.7-3h5.424a1.193,1.193,0,0,0,.2-.019,1.194,1.194,0,0,0,.2.019h5.4c1.415,0,1.916,2.182.689,3",
    transform: "translate(0 -18.389)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarimoscaMainLogo);
export default __webpack_public_path__ + "static/media/marimosca-main-logo.3f7e61cc56ba3d72fd5346960f6bd4ae.svg";
export { ForwardRef as ReactComponent };